import $ from "jquery";
import dayjs from "dayjs";
import { checkNested, getConfig, createGuid, extendArticle } from "./general_functions";
import language from "./translation";

export const warningHtml = (info, where) => {
    return `
                <div class="container alert_main__container ${where}" data-warningid="${info.guid}">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="alert alert-dismissible alert__main alert__main-${info.cssClass}" role="alert">
                                
                                <button type="button" class="close alert__main__close" data-dismiss="${info.guid}" data-contentid="${info.contentId}" aria-label="Close">
                                    <span class="budlight-cross-ui"></span>
                                </button>
                                <div class="row">
                                    <div class="col-12 col-sm-1 pr-sm-0 alert__main__iconplacement">
                                        <img src="/dist/images/${info.icon}" class="alert__main__icon" alt="" />
                                    </div>
                                    <div class="col-12 pl-sm-0 pr-sm-5 col-sm-11">
                                        <h2 class="alert__main__title">${info.title}</h2>
                                        
                                        <div class="alert__main__text">${info.content}</div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              `;
}

export const setWarning = (warnings) => {

    let messages = [];

    // console.log("count warnings",warnings.totalCount, warnings.listOfContent.length);

    if (warnings.totalCount > 0 && warnings.listOfContent.length > 0) {

    
        // if (checkNested(warnings, "listOfContent", "0", "title")) {

            warnings.listOfContent.forEach(item => {
                
                // console.log("rawdata",item);
                
                const extendItem = extendArticle(item);
                
                // console.log("extend", extendItem);
                
                let type = "Drift";
                let placement = "Hele portalen";
                let warnPages = [];
                let title = extendItem.title;
                let content = decodeURIComponent(extendItem.contentObject);
                let intro = extendItem.intro;
                let articleId = window.contentID;
                // let retArray = [];
                let guid = createGuid();
                
                let types = {
                    "Drift" : {
                        icon : "ic-info.svg",
                        cssClass : "info"
                    },
                    "Mindre viktig" : {
                        icon : "ic-pushy-dark.svg",
                        cssClass : "warning"
                    },
                    "Viktig" : {
                        icon : "ic-pushy-red.svg",
                        cssClass : "alert"
                    }
                }
                
                if(extendItem.metaParsed){
                    
                    let itemParsed = extendItem.metaParsed;
                
                    if(itemParsed.beredskapAlvorlighetsgrad){
                        type = itemParsed.beredskapAlvorlighetsgrad;
                    }
                    if(itemParsed.beredskapPlassering){
                
                        let itemPlacement = itemParsed.beredskapPlassering;
                
                        if(itemPlacement.beredskapVisPaaSide){
                            
                            placement = itemPlacement.beredskapVisPaaSide;
                            
                        }
                
                        if(placement === "Underside"){
                            
                            let selectedItems = itemPlacement.beredskapSelectedItems;
                            
                            if(selectedItems){
                                
                                if(selectedItems.length > 0){
                                    
                                    selectedItems.forEach(placethis => {
                                        
                                        warnPages.push(placethis.contentId);
                                        
                                    })
                                    
                                }   
                            }   
                        }
                    }
                }
                
                let itemHtml = warningHtml({
                            title : title,
                            content : content,
                            cssClass: types[type].cssClass,
                            icon: types[type].icon,
                            guid : guid,
                            contentId : extendItem.contentId
                        }, placement.replace(" ", "").toLowerCase());
                
                if(placement == "Underside"){
                    
                    // console.log("underside", articleId, warnPages.indexOf(articleId), warnPages);
                    
                    if(warnPages.indexOf(articleId) > -1){
                        
                        // console.log("match?", title)
                    
                        messages.push(itemHtml);
                        
                    }
                    
                }
                else if (placement == "Forside" && client.template === "frontpage" && articleId === ""){
                    
                    // console.log("forside", articleId)
                    
                    messages.push(itemHtml);
                    
                }
                else if (placement === "Hele portalen") {
                    // hele portalen
                    
                    // console.log("hele portalen");
                    
                    messages.push(itemHtml);
                }
                
                // console.log(retArray);
                
                // let html = retArray.join("");
                
                // return html;
                // console.log("oppsummert", type, placement, warnPages, title, content);  

                // var content = $(`<div class="test">${decodeURIComponent(warning.contentObject)}</div>`);

                // let intro = warning.intro || content.find("p:first").html();
                // let more = ``;
                // let sameAsPage = "";
                // let newTime = ``;
                // let guid = createGuid();
                
                
                // let meta = JSON.parse(decodeURIComponent(warning.metaObject));
                
                // // console.log("meta warning", meta);
                
                // let where = "Hele portalen";
                
                // if(meta.beredskapVisPaaSide){
                //     where = meta.beredskapVisPaaSide;
                //     if(where === "Forside"){
                //         where = "/";
                //     }
                // }
                

                // if (getPageUrl().contentid === warning.contentId) {
                //     sameAsPage = "d-none";
                // }


                // Object.keys(sessionStorage).map(function(c) {
                //     if (c.match("hide-warning")) {
                //         let item = sessionStorage.getItem(c);
                //         item = parseInt(item);
                        
                //         let closedTime =dayjs(item).valueOf();
                //         let msgModTime =dayjs(warning.modified).valueOf();
                //         if(dayjs(warning.modified).valueOf() > dayjs(item).valueOf()) {
                //             $(".header__button__pill.d-none").removeClass("d-none").parents("button").attr("title",language("WARN_CHANGED"));
                            
                //             newTime = `<p class='alert__main__time'>Sist lukket: ${dayjs(item).format("DD.MM.YYYY kl. HH:mm")}. ${language("WARN_UPDATED")}: <span class="alert__main__update">${dayjs(warning.modified).format("DD-MM-YYYY HH:mm")}</span></p>`;
                //         }
                //         else {
                //             newTime = `<p class='alert__main__time'>${language("WARN_UPDATED")}: <span>${dayjs(warning.modified).format("DD.MM.YYYY kl. HH:mm")}</span></p>`;
                            
                //         }
                //     }
                //     else {
                //         newTime = `<p class='alert__main__time'>${language("WARN_UPDATED")}: <span>${dayjs(warning.modified).format("DD.MM.YYYY kl. HH:mm")}</span></p>`;
                //     }
                // });

                // if (content.find("p").length > 1) {
                //     more = `
                //             <p><a href="/article/${warning.contentId}" class="alert__main__link">${language("WARN_GOTOPAGE")}</a></p>`;
                // }
                
                // // console.log("where", where, window.location.pathname);
                // if(where === "Hele portalen" || where === window.location.pathname){
                    
                    

                //     if (sessionStorage.getItem("hide-warning-" + warning.contentId)) {
                //         // console.log("time",sessionStorage.getItem("hide-warning-"+warning.contentId))
                //         sameAsPage = "d-none";
                //         setHeaderWarning();
                //     }
                    
                //     messages.push();
                // }

            });

        // }
    }

    messages = messages.join("");

    return messages;



}
export const getApiWarnings = () => {

    let clientid = getConfig().clientId;

    $.when(
        $.getJSON(window.apiUrl + "/api/PublicContentApi/getcontentlist/" + clientid + "/mal_beredskap/100/0/Modified"),
    ).done(function(warnings) {
        

        let messages = setWarning(warnings);
        
        // console.log("all",messages);

        $("#warnings_container").html(messages);

    });

    $("body").on("click", ".alert__main__close", function() {
        let id = $(this).data("dismiss");
        let contentId = $(this).data("contentid");
        $(`[data-warningid=${id}]`).addClass("d-none");
        sessionStorage.setItem("hide-warning-" + contentId, Date.now());

        setHeaderWarning();
    });
}
export const setHeaderWarning = () => {
    
    // $(".header__button__warning").remove();

    // $("#warning__button__container").html(`
    //         <button class="header__button__warning align-middle" aria-label="warnings" aria-controls="warnings" title="${language("WARN_SECLOSED")}">
    //             !
    //             <span class="header__button__pill d-none" title="${language("WARN_CHANGED_WARN")}"></span>
    //         </button>`)
    
    // $(".header__button__warning").click(function(){
       
    //   $(".header__button__warning").addClass("d-none");
    //   $(".alert_main__container").removeClass("d-none");
        
    // });
    
    return;
}
